import { ENDPOINTS } from "config/constants";
import { useContextController } from "context";
import { logout } from "context/actions";
import { useFetch } from "hooks";
import { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function PublicLayout({ children }: PropsWithChildren) {
  const [{ userData, loadingUser }, dispatch] = useContextController();
  const navigate = useNavigate();
  const location = useLocation();
  const { callFetch } = useFetch("DELETE");
  const isAuthRecovery = location.pathname.startsWith("/forgot-password");

  useEffect(() => {
    if (!isAuthRecovery || loadingUser || !userData) return;

    localStorage.setItem("logout", "true");
    callFetch(ENDPOINTS.account).catch(console.error);
    logout(dispatch);
  }, [isAuthRecovery, loadingUser, userData, callFetch, dispatch]);

  useEffect(() => {
    if (!loadingUser && userData && !isAuthRecovery) {
      navigate("/");
    }
  }, [userData, loadingUser, navigate, isAuthRecovery]);

  return <>{children}</>;
}
